import React from "react";
import PropTypes from "prop-types";
import { getPropsFromData, InputField, TextareaField } from "../../FormField";

const createInputField = (data, fieldName) => <InputField {...getPropsFromData(data, fieldName)} />;
const createTextareaField = (data, fieldName) => (
  <TextareaField {...getPropsFromData(data, fieldName)} />
);

const FamilyRecord = ({ data, index }) => {
  return (
    <tr className="align-top">
      <td>{createInputField(data, `FamilyName${index}`)}</td>
      <td>{createInputField(data, `FamilyRelationship${index}`)}</td>
      <td>{createTextareaField(data, `FamilyMedicalCondition${index}`)}</td>
      <td>{createInputField(data, `FamilyAgeAtDiagnosis${index}`)}</td>
      <td>{createInputField(data, `FamilyAgeAtDeath${index}`)}</td>
      <td>{createTextareaField(data, `FamilyCauseOfDeath${index}`)}</td>
    </tr>
  );
};

FamilyRecord.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number.isRequired,
};

export default FamilyRecord;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201906/FamilyRecord.jsx